let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l2jdZ")).then(() => parcelRequire('9A00a'));